import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import { redirectLegacyConsoleHost } from "@/features/onboarding/api";
import { installUpdateWatcher } from "@/lib/app-update";
import { watchSystemTheme } from "@/lib/theme";
import "@/index.css";

// Compat arbitrage A (2026-07-04) : l'ex-hôte console « dalan.* » redirige
// vers « ada.* » (même chemin) AVANT tout rendu. Retirer après 2026-08-04.
const redirecting = redirectLegacyConsoleHost();

// Suit le thème système quand la préférence est « système » (l'application
// initiale du thème est faite avant le rendu par le script inline d'index.html).
watchSystemTheme();

// Signale une nouvelle version déployée (bandeau « Mettre à jour ») et recharge
// une fois si une page ne se charge plus après un déploiement.
installUpdateWatcher();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container '#root' is missing in index.html");
}

if (!redirecting) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
